import { useIsUnderNewTabletLandscapeWidth } from 'hooks/use-window-size-condition'

export const useIsMobileLayout = useIsUnderNewTabletLandscapeWidth
